import { EVerticalNames } from '@constants';
import { IUserInfo, IUser } from '@sdk/contracts';
import { Form, FormInstance, Radio } from 'antd';
import { useTranslation } from 'react-i18next';

import { AutonomousCommunitySelector } from '../Form';
import { ExamGroupSelectorPCE } from '../Form/ExamGroupSelectorPCE';
import {
  UserInfoBranchSelector,
  UserInfoDegreeSelector,
  UserInfoUniversitySelector
} from '../Form/UserInfo';

import { Wrapper, TitleWrapper } from './PceFormContent.styles';

type PceFormContentProps = {
  form: FormInstance<IUserInfo>;
  profile?: IUser;
  isManager: boolean;
};

export const PceFormContent: React.FC<PceFormContentProps> = ({ form, profile, isManager }) => {
  const { t } = useTranslation(['DefaultTranslations', 'StudentProfileConfigurationTranslations']);
  const userInfo = profile?.userInfo;
  const data = userInfo?.pceUserInfo;

  return (
    <Wrapper>
      {isManager && <TitleWrapper>{t(EVerticalNames.UNI)} | PCE</TitleWrapper>}
      <Form.Item
        name={['pceUserInfo', 'studyBranch']}
        label={t('StudentProfileConfigurationTranslations:STUDY_BRANCH')}
        initialValue={data?.studyBranch}>
        <UserInfoBranchSelector objName="pceUserInfo" />
      </Form.Item>
      <Form.Item
        name={['pceUserInfo', 'degree']}
        label={t('StudentProfileConfigurationTranslations:DEGREE')}
        initialValue={data?.degree}>
        <UserInfoDegreeSelector objName="pceUserInfo" />
      </Form.Item>
      <Form.Item
        name={['pceUserInfo', 'university']}
        label={t('StudentProfileConfigurationTranslations:UNIVERSITY')}
        initialValue={data?.university}>
        <UserInfoUniversitySelector objName="pceUserInfo" />
      </Form.Item>
      <Form.Item
        name={['examGroups']}
        label={t('StudentProfileConfigurationTranslations:EXAM_GROUPS')}
        initialValue={userInfo?.examGroups}>
        <ExamGroupSelectorPCE
          value={userInfo?.examGroups}
          onChange={(value: string[] | string) =>
            form.setFieldsValue({ examGroups: Array.isArray(value) ? value : [value] })
          }
        />
      </Form.Item>
      <Form.Item
        name={['pceUserInfo', 'autonomousCommunity']}
        label={t('AUTONOMOUS_COMMUNITY')}
        rules={[{ required: true, message: t('AUTONOMOUS_COMMUNITY') }]}>
        <AutonomousCommunitySelector
          onChange={value =>
            form.setFieldsValue({
              pceUserInfo: { ...form.getFieldValue('pceUserInfo'), autonomousCommunity: value }
            })
          }
        />
      </Form.Item>
      <Form.Item
        name={['pceUserInfo', 'needVisa']}
        label={t('StudentProfileConfigurationTranslations:DO_YOU_NEED_STUDENT_VISA')}
        initialValue={data?.needVisa}>
        <Radio.Group
          onChange={e =>
            form.setFieldsValue({
              pceUserInfo: { ...form.getFieldValue('pceUserInfo'), needVisa: e.target.value }
            })
          }>
          <Radio value={true}>{t('YES')}</Radio>
          <Radio value={false}>{t('NO')}</Radio>
        </Radio.Group>
      </Form.Item>
      <Form.Item
        name={['pceUserInfo', 'hasCertificateDegree']}
        label={t('StudentProfileConfigurationTranslations:HAS_CERTIFICATE_DEGREE')}
        initialValue={data?.hasCertificateDegree}>
        <Radio.Group
          onChange={e =>
            form.setFieldsValue({
              pceUserInfo: {
                ...form.getFieldValue('pceUserInfo'),
                hasCertificateDegree: e.target.value
              }
            })
          }>
          <Radio value={true}>{t('YES')}</Radio>
          <Radio value={false}>{t('NO')}</Radio>
        </Radio.Group>
      </Form.Item>
      <Form.Item
        name={['pceUserInfo', 'hasNotesEquivalence']}
        label={t('StudentProfileConfigurationTranslations:HAS_NOTES_EQUIVALENCE')}
        initialValue={data?.hasNotesEquivalence}>
        <Radio.Group
          onChange={e =>
            form.setFieldsValue({
              pceUserInfo: {
                ...form.getFieldValue('pceUserInfo'),
                hasNotesEquivalence: e.target.value
              }
            })
          }>
          <Radio value={true}>{t('YES')}</Radio>
          <Radio value={false}>{t('NO')}</Radio>
        </Radio.Group>
      </Form.Item>
    </Wrapper>
  );
};
